import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const SearchTabs = ({ onSearch, isSearching }) => {
  const [activeTab, setActiveTab] = useState('phone');
  const [searchValue, setSearchValue] = useState('');

  const tabs = [
    { id: 'phone', label: 'Teléfono', icon: 'Phone', placeholder: 'Ej: 555-1234' },
    { id: 'plates', label: 'Placas', icon: 'Car', placeholder: 'Ej: ABC-123' },
    { id: 'folio', label: 'Folio', icon: 'FileText', placeholder: 'Ej: ORD-2026-001' }
  ];

  const handleSearch = () => {
    if (searchValue?.trim()) {
      onSearch(activeTab, searchValue?.trim());
    }
  };

  const handleKeyPress = (e) => {
    if (e?.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="bg-card rounded-xl shadow-elevation-2 p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon name="Search" size={24} color="var(--color-primary)" />
        <h2 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground">
          Buscar Orden
        </h2>
      </div>
      <div className="flex gap-2 mb-4 overflow-x-auto pb-2">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => {
              setActiveTab(tab?.id);
              setSearchValue('');
            }}
            className={`
              flex items-center gap-2 px-4 py-2.5 rounded-lg font-medium
              transition-all duration-250 whitespace-nowrap flex-shrink-0
              ${activeTab === tab?.id
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'bg-muted text-muted-foreground hover:bg-muted/80'
              }
            `}
          >
            <Icon name={tab?.icon} size={18} />
            <span className="text-sm md:text-base">{tab?.label}</span>
          </button>
        ))}
      </div>
      <div className="flex flex-col md:flex-row gap-3">
        <div className="flex-1">
          <Input
            type="text"
            placeholder={tabs?.find(t => t?.id === activeTab)?.placeholder}
            value={searchValue}
            onChange={(e) => setSearchValue(e?.target?.value)}
            onKeyPress={handleKeyPress}
            disabled={isSearching}
            className="w-full"
          />
        </div>
        <Button
          variant="default"
          iconName="Search"
          iconPosition="left"
          onClick={handleSearch}
          loading={isSearching}
          disabled={!searchValue?.trim()}
          className="w-full md:w-auto"
        >
          Buscar
        </Button>
      </div>
    </div>
  );
};

export default SearchTabs;